var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"option-button",on:{"click":_vm.handleClick}},[_vm._m(0),_c('div',{staticClass:"option-button__text"},[_vm._v(_vm._s(_vm.txt))])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"option-button__bg"},[_c('img',{attrs:{"src":require("@/render/assets/images/grading/button_bg.png")}})])
}]

export { render, staticRenderFns }